import { render, staticRenderFns } from "./ArchiveCard.vue?vue&type=template&id=6fc069a6&scoped=true&"
import script from "./ArchiveCard.vue?vue&type=script&lang=js&"
export * from "./ArchiveCard.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveCard.vue?vue&type=style&index=0&id=6fc069a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc069a6",
  null
  
)

export default component.exports